import { useEffect, useState } from 'react';
import { css, etiColors, mediaQueries } from '@eti/styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const labelStyles = size => css`
  display: inline-block;
  height: 30px;
  position: relative;
  width: 48px;

  @media ${mediaQueries.large.up} {
    height: ${size === 'large' ? '30px' : '22px'};
    width: ${size === 'large' ? '48px' : '35px'};
  }
`;
const sliderStyles = (color, size, hasError, isDisabled) => css`
  &::before {
    background-color: ${etiColors.white};
    border-radius: 50%;
    bottom: 2px;
    content: '';
    height: 26px;
    left: 2px;
    position: absolute;
    transition: 0.4s;
    width: 26px;

    @media ${mediaQueries.large.up} {
      height: ${size === 'large' ? '26px' : '18px'};
      width: ${size === 'large' ? '26px' : '18px'};
    }

    [dir='rtl'] & {
      left: initial;
      right: 2px;
    }
  }

  input:checked ~ & {
    background-color: ${color};
  }

  input:focus ~ & {
    box-shadow: 0 0 4px ${etiColors.grayScale[9]};
  }

  input:checked ~ &::before {
    transform: translateX(18px);

    [dir='rtl'] & {
      transform: translateX(-18px);
    }

    @media ${mediaQueries.large.up} {
      transform: translateX(${size === 'large' ? '18px' : '13px'});

      [dir='rtl'] & {
        transform: translateX(${size === 'large' ? '-18px' : '-13px'});
      }
    }
  }

  background-color: ${etiColors.grayScale[6]};
  border-radius: 18px;
  box-shadow: ${hasError && `0 0 4px ${etiColors.critical.solid}`};
  cursor: ${isDisabled ? 'no-drop' : 'pointer'};
  inset: 0;
  position: absolute;
  transition: 0.4s;
`;
const inputStyles = css`
  height: 0;
  opacity: 0;
  width: 0;
`;
const {
  confirmation: {
    solid: defaultColor
  }
} = etiColors;
const SwitchButton = _ref => {
  let {
    color = defaultColor,
    id,
    onChange = () => {},
    size = 'standard',
    hasError,
    isChecked = false,
    isDisabled
  } = _ref;
  const [isSwitchButtonChecked, setIsSwitchButtonChecked] = useState(isChecked);
  useEffect(() => {
    setIsSwitchButtonChecked(isChecked);
  }, [isChecked]);
  const handleChange = e => {
    setIsSwitchButtonChecked(e.target.checked);
    onChange(e);
  };
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    _jsxs("label", {
      className: labelStyles(size),
      "data-testid": id,
      htmlFor: id,
      children: [/*#__PURE__*/_jsx("input", {
        checked: isSwitchButtonChecked,
        className: inputStyles,
        color: color,
        "data-testid": `input-${id}`,
        disabled: isDisabled,
        id: id,
        name: id,
        onChange: handleChange,
        type: "checkbox",
        value: isSwitchButtonChecked.toString()
      }), /*#__PURE__*/_jsx("span", {
        className: sliderStyles(color, size, hasError, isDisabled),
        "data-testid": `slider-${id}`
      })]
    })
  );
};
export default SwitchButton;